var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.options, function (option, index) {
      return _c("JadeListItem", {
        key: `jade-list-item-selection-${index}`,
        staticClass: "jade-list-item-selection",
        attrs: {
          compact: "",
          as: "label",
          label: option.label,
          for: `input-${index}`,
          "data-testid": `jade-list-item-${index}`,
        },
        on: {
          onClick: function ($event) {
            return _vm.handleSelect(option)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "trailing",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "jade-list-item-selection__trailing" },
                    [
                      _c(_vm.component, {
                        tag: "component",
                        attrs: {
                          name: "option",
                          value: option.selected,
                          supportText: option.description,
                          id: `input-${index}`,
                        },
                        on: {
                          "update:value": function ($event) {
                            return _vm.$set(option, "selected", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }